import React from "react";
import { AppShell, ScrollArea } from "@mantine/core";

import ScollableLinks from "#root/components/NavbarLinks/ScollableLinks/ScollableLinks";
import FixHeader from "#root/components/NavbarLinks/FixHeader/FixHeader";
import FixFooter from "#root/components/NavbarLinks/FixFooter/FixFooter";

const NavbarLinks = ({ toggle }: { toggle: () => void }) => {
  return (
    <AppShell.Navbar p="md" aria-label="Main navigation">
      {/* 🧑‍🚀 Fixed User Section */}
      <AppShell.Section aria-label="User account menu">
        <FixHeader toggle={toggle} />
      </AppShell.Section>

      {/* 🌍 Main Navigation Links */}
      <AppShell.Section grow my="md" component={ScrollArea} aria-label="Navigation links">
        <ScollableLinks toggle={toggle} />
      </AppShell.Section>

      {/* 👣 Footer (login, logout, dashboard, etc.) */}
      <AppShell.Section aria-label="Footer">
        <FixFooter toggle={toggle} />
      </AppShell.Section>
    </AppShell.Navbar>
  );
};

export default NavbarLinks;
